export const MESSAGE_CARTE_LUE =
  "J'ai lu la carte. Vérifie toutes les informations avant de confirmer : e-mail, numéros, nom et adresse. Des erreurs de lecture sont possibles.";
